export interface IIssueStatus {
    id: number,
    name: string
}

export enum IssueStatus {
    Active = 0,
    Dimage = 1,
    Allotted = 2,
}